export default __webpack_public_path__ + "static/media/transfer-sent-for-approval.27b4ea34.png";